import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import SwapHorizontalCircleOutlinedIcon from "@material-ui/icons/SwapHorizontalCircleOutlined";

const useStyles = makeStyles({
  root: {
    width: "100%",
    position: "fixed",
    left: "0px",
    bottom: "0px",
  },
});

const NavBottom = (props) => {
  const classes = useStyles();

  const [value, setValue] = React.useState("recents");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const toPage = (page) => {
    props.history.push(`/app/${page}`);
  };

  return (
    <BottomNavigation
      value={value}
      onChange={handleChange}
      className={classes.root}
    >
      <BottomNavigationAction
        label="Portal"
        value="portals"
        icon={<HomeOutlinedIcon />}
        onClick={() => toPage("portal")}
      />
      <BottomNavigationAction
        label="Transacciones"
        value="transactions"
        icon={<SwapHorizontalCircleOutlinedIcon />}
        onClick={() => toPage("transactions")}
      />
    </BottomNavigation>
  );
};

export default withRouter(NavBottom);
